import { combineReducers, createStore, applyMiddleware } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import {
  sidebarReducer,
  themeReducer,
  authenticationReducer,
  userReducer,
  alertReducer,
  companyReducer,
  placementTestReducer,
  groupReducer,
  uiReducer,
  unitReducer,
  infoSheetReducer,
  moduleReducer,
  coursesReducer,
  languageReducer,
} from '../../redux/reducers/index';

const middlewares = [thunk];
// const middlewares = [thunk, logger];

const appReducer = combineReducers({
  toastr: toastrReducer,
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  placementTest: placementTestReducer,
  authentication: authenticationReducer,
  user: userReducer,
  alert: alertReducer,
  company: companyReducer,
  group: groupReducer,
  ui: uiReducer,
  units: unitReducer,
  modules: moduleReducer,
  infoSheet: infoSheetReducer,
  courses: coursesReducer,
  language: languageReducer,
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'USER_LOGGED_OUT') {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }

  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(...middlewares));

export default store;
